<template>

  <v-data-table
      :headers="headers1"
      :items="orders"
      :items-per-page="itemsPerPage"
      item-key="orderId"
      class="elevation-1 orders"
      disable-sort-by
      single-expand
      show-expand
      :loading="isLoading"
      :locale="systemLocale">
    <template v-slot:progress>
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.sessionNumber="{ item }">
      {{ item.sessionNumber }}
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.organizationName="{ item }">
      <route-link-with-tip
          v-if="isAdmin"
          :text="item.organizationName"
          :tip="$t('Просмотр организации')"
          :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
      <span v-else>
        {{ item.organizationName }}
      </span>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.userName="{ item }">
      <route-link-with-tip
          v-if="isAdmin"
          :text="item.userName"
          :tip="$t('Просмотр пользователя')"
          :to="{ path: `${urlRootPath}/user/${item.userId}` }" />
      <span v-else>
        {{ item.userName }}
      </span>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.orderDate="{ item }">
      {{ item.orderDate
        ? $moment(item.orderDate).format('DD.MM.YYYY HH:mm:ss')
        : null }}
    </template>
    <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
    <template v-slot:item.clientOrganizationFullName="{ item }">
      <template v-if="item.clientOrganizationFullName && item.clientOrganizationInn">
        {{ item.clientOrganizationFullName }} / {{ item.clientOrganizationInn }}
      </template>
    </template>
    <!-- eslint-disable-next-line vue/valid-v-slot -->
    <template v-slot:item.isWinner="{ item }">
      <icon-tip
          v-if="item.isWinner"
          icon="done"
          icon-color="green darken-2" />
      <!-- <v-checkbox
          v-model="item.isWinner"
          dense
          :height="10"
          disabled /> -->
    </template>
    <template v-slot:expanded-item="{ headers, item } ">
      <td :colspan="headers.length">
        <v-row class="py-2">
          <v-col :cols="item.additionalInfo || item.fileId ? 9 : 12">
            <v-data-table
                :key="item.orderId"
                :headers="headers2"
                :items="item.premiums || []"
                :items-per-page="nestedItemsPerPage"
                item-key="positionId"
                class="premiums"
                disable-sort-by
                dense
                hide-default-footer
                :locale="systemLocale">
              <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
              <template v-slot:item.positionDescription="{ item }">
                {{ item.positionDescription }}
              </template>
              <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
              <template v-slot:item.premium="{ item }">
                {{ item.premium }}
              </template>
              <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
              <template v-slot:item.orderCost="{ item }">
                {{ item.orderCost }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </td>
    </template>
  </v-data-table>
</template>

<style scoped>
  .orders::v-deep td:nth-child(3) {
   word-break: break-all;
   max-width: 450px;
  }
  .orders::v-deep td:nth-child(1) {
    min-width: 200px;
  }
  .premiums::v-deep td:nth-child(1) {
    word-break: break-all;
    max-width: 550px;
  }
  .premiums::v-deep td:nth-child(2) {
    min-width: 150px;
  }
</style>

<script>
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'
  import IconTip from '@/components/reused/ui/IconTip.vue'
  // import BtnIconTip from '@/components/reused/ui/BtnIconTip'
  // import TextView from '@/components/reused/ui/TextView.vue'

  export default {
    components: {
      RouteLinkWithTip,
      IconTip
      // BtnIconTip,
      // TextView
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      value: {
        type: Array,
        default: () => ([])
      },
      isFixPrice: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      orders: {
        type: Array,
        default: () => ([])
      }
    },
    data () {
      return {
        isLoading: false,
        itemsPerPage: 5,
        nestedItemsPerPage: -1,
        winners: []
      }
    },
    computed: {
      headers1 () {
        return [
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Пользователь'), sortable: false, value: 'userName' },
          { text: this.$t('Клиент'), sortable: false, value: 'clientOrganizationFullName' },
          { text: this.$t('Время выставления'), sortable: false, value: 'orderDate' },
          { text: this.$t('Победитель'), sortable: false, value: 'isWinner' },
          { text: '', value: 'data-table-expand' }
        ]
      },
      headers2 () {
        return [
          { text: this.$t('Наименование позиции'), sortable: false, value: 'positionDescription' },
          { text: this.$t(this.isFixPrice ? 'Цена' : 'Значение дифференциала'), sortable: false, value: 'premium' }
        ]
      }
    },
    watch: {
      value: {
        deep: true,
        immediate: true,
        handler (newVal) {
          if (newVal) {
            this.initWinners(newVal)
          }
        }
      }
    },
    methods: {
      initWinners: function (winners) {
        this.winners = winners
      },
      winnerChange: function ($event, item) {
        if ($event) {
          this.winners.push(item)
        } else {
          this.winners = this.winners.filter(w => w.orderId !== item.orderId)
        }
        this.$emit('input', this.winners)
      }
    }
  }
</script>
